import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PhoneRegularAi from './phone-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PhoneRegularAi {...validProps} />;
}
SvgComponent.iconName = 'phoneRegularAi';

export const PhoneRegularAiIcon = svgIconWrapper(SvgComponent);
